import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import type { NewsletterLead } from "./types";

interface LeadEditFormProps {
  lead: NewsletterLead;
  onSuccess: () => void;
  onCancel: () => void;
}

export const LeadEditForm = ({ lead, onSuccess, onCancel }: LeadEditFormProps) => {
  const [formData, setFormData] = useState({
    email: lead.email,
    full_name: lead.full_name || "",
    last_name: lead.last_name || "",
    company: lead.company || "",
    role_title: lead.role_title || "",
    category: lead.category,
  });
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      const { error } = await supabase
        .from('newsletter_leads')
        .update(formData)
        .eq('id', lead.id);

      if (error) throw error;

      toast({
        title: "Success",
        description: "Lead updated successfully",
      });
      
      onSuccess();
    } catch (error) {
      console.error('Error updating lead:', error);
      toast({
        title: "Error",
        description: "Failed to update lead",
        variant: "destructive",
      });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="space-y-2">
        <Input
          placeholder="Email"
          value={formData.email}
          onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))}
        />
        <Input
          placeholder="Full Name"
          value={formData.full_name}
          onChange={(e) => setFormData(prev => ({ ...prev, full_name: e.target.value }))}
        />
        <Input
          placeholder="Last Name"
          value={formData.last_name}
          onChange={(e) => setFormData(prev => ({ ...prev, last_name: e.target.value }))}
        />
        <Input
          placeholder="Company"
          value={formData.company}
          onChange={(e) => setFormData(prev => ({ ...prev, company: e.target.value }))}
        />
        <Input
          placeholder="Role"
          value={formData.role_title}
          onChange={(e) => setFormData(prev => ({ ...prev, role_title: e.target.value }))}
        />
        <Input
          placeholder="Category"
          value={formData.category}
          onChange={(e) => setFormData(prev => ({ ...prev, category: e.target.value }))}
        />
      </div>
      
      <div className="flex justify-end space-x-2">
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit">
          Save Changes
        </Button>
      </div>
    </form>
  );
};